import InputTypes from '@/constants/InputTypes';
import {
  END_CHAT,
  GROUP,
  NEXT_BLOCK,
  SPECIFIC_BLOCK,
} from '@/constants/BlockNextTypes';

export function getActiveBlock(conversation) {
  if (Array.isArray(conversation) && conversation.length > 0) {
    const conv = [...conversation];
    const activeBlock = conv.pop();
    return activeBlock;
  }
}

export function shouldGoNext(activeBlock) {
  if (typeof activeBlock === 'undefined') return true;

  const inputTypeCheck = activeBlock.inputType === InputTypes.NONE;
  const answerCheck = hasAnswer(activeBlock);
  const emptyData = isNoData(activeBlock);
  return inputTypeCheck || answerCheck || emptyData;
}

export function hasAnswer(activeBlock) {
  if (isSkipped(activeBlock)) return true;

  if (activeBlock?.answer) {
    if (
      typeof activeBlock?.answer === 'object' &&
      !Array.isArray(activeBlock?.answer)
    ) {
      return true;
    } else {
      if (activeBlock?.answer?.length > 0) return true;
    }
  }

  return false;
}

export function isSkipped(activeBlock) {
  return activeBlock?.isSkipped === true;
}

export function isNoData(activeBlock) {
  return activeBlock?.noData === true;
}

export function getNextObj(activeBlock) {
  if (isSkipped(activeBlock)) return activeBlock.skip?.next;

  if (activeBlock.inputType === InputTypes.OPTIONS) {
    const selectedAnswer = activeBlock?.options?.answers.find(
      answer => answer.title === activeBlock?.answer,
    );
    const selectedAnswerForDisplay = activeBlock?.answerForDisplay
    return selectedAnswer?.next || selectedAnswerForDisplay?.next;
  }

  if (activeBlock.inputType === InputTypes.MULTIPLE_SELECT_OPTIONS) {
    if (activeBlock?.answer?.length === 1 && activeBlock?.answer[0]?.next) {
      return activeBlock?.answer[0]?.next;
    }
  }

  if (
    activeBlock.inputType === InputTypes.USER_TYPE ||
    activeBlock.inputType === InputTypes.JOB_TYPE
  ) {
    return activeBlock.answer?.next;
  }

  if (isNoData(activeBlock)) {
    return activeBlock?.notFound.next;
  }

  return activeBlock?.next;
}

export function shouldFinishChat(activeBlock) {
  return getNextObj(activeBlock)?.type === END_CHAT;
}

export function shouldUpdateActiveGroup(activeBlock) {
  return getNextObj(activeBlock)?.type === GROUP;
}

export function hasAfterMessage(activeBlock) {
  return !!getNextObj(activeBlock)?.message;
}

export function getAfterMessageBlock(activeBlock) {
  const nextObj = getNextObj(activeBlock);
  return {
    originalBlockId: activeBlock?.id,
    isAfterMessage: true,
    message: nextObj.message,
    blockType: 'MESSAGE',
    inputType: InputTypes.NONE,
    dataType: 'NONE',
    options: {},
    skip: {
      enabled: false,
      text: 'Skip',
      next: {
        type: nextObj.type,
        id: nextObj.id,
      },
    },
    next: {
      type: nextObj.type,
      id: nextObj.id,
    },
  };
}

export function getNextId(activeBlock) {
  return getNextObj(activeBlock)?.id;
}

export function getNextBlock(activeBlock, activeGroupId, flow) {
  return findByNextObj(
    getNextObj(activeBlock),
    activeBlock,
    activeGroupId,
    flow,
  );
}

function findByNextObj(nextObj, activeBlock, activeGroupId, flow) {
  if (nextObj.type === GROUP) {
    const nextGroup = flow.groups.find(group => group.id === nextObj.id);
    if (typeof nextGroup !== 'undefined' && nextGroup?.blocks?.length > 0) {
      return nextGroup.blocks[0];
    }
  } else if (nextObj.type === SPECIFIC_BLOCK) {
    const group = flow.groups.find(group => group.id === activeGroupId);
    if (typeof group !== 'undefined') {
      return group.blocks.find(block => block.id === nextObj.id);
    }
  } else if (nextObj.type === NEXT_BLOCK) {
    const group = flow.groups.find(group => group.id === activeGroupId);
    const blockIndex = group.blocks.findIndex(block => {
      if (activeBlock.isAfterMessage) {
        return block.id === activeBlock?.originalBlockId;
      } else {
        return block.id === activeBlock?.id;
      }
    });
    if (blockIndex !== -1 && blockIndex !== group.blocks.length - 1) {
      return group.blocks[blockIndex + 1];
    }
  }
  return undefined;
}
